import classNames from '@utils/classnames';
import React, { useRef } from 'react';

import { controlClassName } from '../form/control';

export interface InputProps {
  id?: string;
  value: string;
  onBlur?: (e: React.FocusEvent<any>) => void;
  onFocus?: (e: React.FocusEvent<any>) => void;
  onChange: (newValue: string) => void;
  type: 'text' | 'email' | 'password' | 'number' | 'date' | 'time' | 'tel';
  step?: string;
  isInvalid?: boolean;
  isDisabled?: boolean;
  placeholder?: string;
  autoComplete?: string;
  iconLeft?: React.ReactElement;
  iconRight?: React.ReactElement;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  spellCheck?: boolean;
  className?: string;
}

export const Input: React.FC<InputProps> = (props) => {
  const {
    id,
    value,
    onBlur,
    onFocus,
    isInvalid,
    isDisabled,
    placeholder,
    step,
    autoComplete,
    iconLeft,
    iconRight,
    onKeyDown,
    spellCheck,
    className,
  } = props;
  let type = props.type;
  let onChange = props.onChange;
  if (type === 'number') {
    type = 'text';
    onChange = (newValue) => {
      let cleanedValue = newValue.replace(/[^0-9,.]+/g, '').replace(/,+/g, '.');
      if (cleanedValue.length > 1 && cleanedValue[0] === '0') {
        cleanedValue = cleanedValue.substring(1);
      }
      props.onChange(cleanedValue);
    };
  }
  const inputRef = useRef<null | HTMLInputElement>(null);

  return (
    <div
      className={classNames(controlClassName({ isInvalid, isDisabled }), 'flex items-center gap-2 px-2.5', className)}
      onClick={() => inputRef.current?.focus()}
    >
      {iconLeft ? <span className="flex shrink-0 items-center text-fg-muted">{iconLeft}</span> : null}
      <input
        id={id}
        ref={inputRef}
        type={type}
        value={value}
        onBlur={onBlur}
        onFocus={onFocus}
        placeholder={placeholder}
        onChange={(evt) => onChange(evt.target.value)}
        className="block h-full w-full min-w-0 bg-transparent text-fg outline-hidden disabled:text-fg-muted"
        disabled={isDisabled}
        autoComplete={autoComplete ?? 'off'}
        step={step}
        onKeyDown={onKeyDown}
        spellCheck={spellCheck}
      />
      {iconRight ? <span className="flex shrink-0 items-center text-fg-muted">{iconRight}</span> : null}
    </div>
  );
};
